'use client';

import { defaultsDeep } from 'lodash-es';

export async function fetchViaProxy(url, options = {}) {
  if (!url.startsWith('/proxy')) {
    throw new Error('Invalid proxy url');
  }

  const reqOptions = defaultsDeep(options, {
    headers: {
      'Content-Type': 'application/json',
    },
  });

  const res = await fetch(url, reqOptions);

  if (res.ok) {
    return {
      ok: true,
      data: await res.json(),
    };
  }

  return {
    ok: false,
    status: res.status,
    statusText: res.statusText,
  };
}
